
/*
 * @Author: wp
 * @Date: 2023-01-10 16:36:35
 * @Descripttion:
 */
export default ({ app, req }, inject) => {
    // 接口配置
    let host

    if (process.server) {
        // 在服务器端获取
        host = req.headers.host
    } else {
        // 在客户端获取
        const { origin: clientHost } = new URL(window.location.href)
        host = clientHost
    }
    // const _LOCAL_URL = 'http://127.0.0.1:7777/ssrApi'
    const _LOCAL_URL = host + '/ssrApi'
    const _API = {
        // 获取热门游戏
        gamePopular(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/popular',
                method: 'post',
                data
            })
        },
        // 口令
        getshibboleth(data) {
            return app.$requestApi({
                url: '/activity/shibboleth/get',
                method: 'get',
                data
            })
        },
        // 获取所有游戏
        gameAll(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/all',
                method: 'post',
                data
            })
        },
        // 获取游戏详情配置
        getGameConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/config',
                method: 'post',
                data
            })
        },
        // 游戏快速回收集合
        gameAllRecovery(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/rapid/recovery/list',
                method: 'post',
                data
            })
        },
        // 游戏是否支持快速回收
        gameAllRecoverySupport(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/rapid/recovery/support',
                method: 'post',
                data
            })
        },
        // 卖家获取有回收权限的游戏列表
        recycleGameAll(data) {
            return app.$requestApi({
                url: '/merchant/mer/recycle/game/list',
                method: 'post',
                data
            })
        },
        // 商家回收所有游戏
        reGameAll(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/permission/games',
                method: 'post',
                data
            })
        },
        // 获取游戏分类
        gameAllCatalogueSSR(data) {
            return app.$requestApi({
                url: _LOCAL_URL + '/homepage/public/game/catalogue',
                method: 'post',
                data
            })
        },
        gameAllCatalogue(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/catalogue',
                method: 'post',
                data
            })
        },
        // 获取商品分类
        goodsCatalogue(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/goods/catalogue',
                method: 'post',
                data
            })
        },
        // 最新成交
        transactionPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/transaction/page',
                method: 'post',
                data
            })
        },
        // 我要卖---区服树
        treeGameProperTies(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/treeGameProperTies',
                method: 'post',
                data
            })
        },
        // 属性对照表
        listGoodsPropertyConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/listGoodsPropertyConfig',
                method: 'post',
                data
            })
        },
        // 属性对照表的选项
        listGoodsPropertyConfigOptions(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/listGoodsPropertyConfigOptions',
                method: 'post',
                data
            })
        },
        // 发布商品
        saveGoods(data) {
            return app.$requestApi({
                url: `/web-client/v2/userCenter${data.action.edit ? '/updateGoods' : '/saveGoods'}`,
                method: 'post',
                data
            })
        },
        // 服务费
        getFee(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/calculateTransactionFeeNew',
                method: 'post',
                data
            })
        },
        // 砍价服务费
        getBargainFee(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/calculateTransactionFee',
                method: 'post',
                data
            })
        },
        // 我的订单详情
        orderDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/order/detail',
                method: 'post',
                data
            })
        },
        // 修改商品价格
        updatePrice(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/updatePrice',
                method: 'post',
                data
            })
        },
        // 修改商品状态
        updateGoodsStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/updateStatus',
                method: 'post',
                data
            })
        },
        // 商品曝光
        addGoodsTempHeat(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/addGoodsTempHeat',
                method: 'post',
                data
            })
        },
        // 收藏商品列表
        collectionList(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/page',
                method: 'post',
                data
            })
        },
        // 获取当前用户收藏的商品条件
        getCollectionSearchInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/get/my/collect/goods/search/info',
                method: 'get',
                data
            })
        },
        // 查询当前用户收藏列表是否有失效商品
        userInvalidGoodsAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/user/invalid/goods',
                method: 'get',
                data
            })
        },

        // 剔除当前用户收藏列表的失效商品
        cancelInvalidGoodsAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/cancel/invalid/goods',
                method: 'post',
                data
            })
        },

        // 取消收藏
        collectionCancel(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/cancel',
                method: 'post',
                data
            })
        },
        // 批量取消收藏
        collectionCancelBatch(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/cancel/batch',
                method: 'post',
                data
            })
        },
        // 加入收藏
        collectionAdd(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/add',
                method: 'post',
                data
            })
        },
        // 曝光收藏提醒
        useExposureCollcetion(data) {
            return app.$requestApi({
                url: '/web-client/v2/collection/exposure/goods',
                method: 'get',
                data
            })
        },
        // 商品收藏状态
        collectionGoodsStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/collectionStatus',
                method: 'post',
                data
            })
        },
        // 获取引导收藏提醒参数
        getExposureCollectionTips(data) {
            return app.$requestApi({
                url: '/web-client/v2/get/collection/expose/tip',
                method: 'post',
                data
            })
        },
        // 获取发布商品的详情
        goodsGoodsDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goodsGoodsDetails',
                method: 'post',
                data
            })
        },
        gameGoodsDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/goods/details/orderNo',
                method: 'get',
                data
            })
        },
        //获取相似商品
        similarGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/recommend/goodsSimilarity',
                method: 'post',
                data
            })
        },
        //获取推荐商品
        recommendGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/recommend/recommendGoods',
                method: 'post',
                data
            })
        },
        // 订单列表
        orderList(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/order/page',
                method: 'post',
                data
            })
        },
        // 售后列表
        afterSalesOrderList(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/order/page',
                method: 'post',
                data
            })
        },
        // 通用工单部分退款获取到手金额
        getHandMoney(data) {
            return app.$requestApi({
                url: '/workorder/general/order/refund/get/to/hand/money',
                method: 'post',
                data
            })
        },
        // 通用工单部分退款
        upOrderRefund(data) {
            return app.$requestApi({
                url: '/workorder/general/order/refund',
                method: 'post',
                data
            })
        },
        // 申请售后类型
        afterPermisitons(data) {
            return app.$requestApi({
                url: '/web-client/v2/afterSales/order/order/permisitons',
                method: 'post',
                data
            })
        },
        // 申请售后
        afterApply(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/apply',
                method: 'post',
                data
            })
        },
        // 申请售后详情
        afterDetail(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/order/detail',
                method: 'post',
                data
            })
        },
        // 申请售后未评论
        afterDetailCommentN(data) {
            return app.$requestApi({
                url: '/web-client/v2/afterSales/order/evaluation/nocomment',
                method: 'post',
                data
            })
        },
        // 申请售后已评论
        afterDetailCommentY(data) {
            return app.$requestApi({
                url: '/web-client/v2/afterSales/order/evaluation/commented',
                method: 'post',
                data
            })
        },
        // 评论
        afterDetailComment(data) {
            return app.$requestApi({
                url: '/web-client/v2/afterSales/order/evaluation/commit',
                method: 'post',
                data
            })
        },
        // 卖家中心
        sellerCenter(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/pageGoods',
                method: 'post',
                data
            })
        },
        // 卖家中心--已出售详情
        sellerCenterGoodsOrderDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/getGoodsOrderDetails',
                method: 'post',
                data
            })
        },
        // 商品状态
        listGoodsStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listGoodsStatus',
                method: 'post',
                data
            })
        },
        // 订单状态
        listOrderStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listOrderStatus',
                method: 'post',
                data
            })
        },
        // 删除商品
        deleteGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/deleteGoods',
                method: 'post',
                data
            })
        },
        // 商品列表
        goodsList(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/page',
                method: 'post',
                data
            })
        },
        // 商品详情
        goodsDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/goodsDetails',
                method: 'post',
                data
            })
        },
        /** @通用商品 start **/
        // 通用商品游戏类目列表
        getGeneralGoodsCateItems(data) {
            return app.$requestApi({
                url: '/web-client/hot_search/public/general_games/categories',
                method: 'get',
                data
            })
        },
        // 通用商品游戏类目树
        getGeneralGoodsCateTree(data) {
            return app.$requestApi({
                url: '/web-client/hot_search/public/general_games/categories_tree',
                method: 'post',
                data
            })
        },
        // 通用商品options
        getGeneralGoodsOptions(data) {
            return app.$requestApi({
                url: '/web-client/hot_search/public/goods_property/options',
                method: 'post',
                data
            })
        },
        // 通用商品列表
        getGeneralList(data) {
            return app.$requestApi({
                url: '/web-client/public/general_goods/page',
                method: 'post',
                data
            })
        },
        // 通用商品属性options搜索
        getGoodsPropertyOptionsSearch(data) {
            return app.$requestApi({
                url: '/web-client/hot_search/public/goods_property/options_search',
                method: 'post',
                data
            })
        },
        // 校验通用商品是否可下单
        getGeneralGoodsValidForPlaceOrder(data) {
            return app.$requestApi({
                url: `/web-client/user/general_goods/valid-for-place-order`,
                method: 'post',
                data
            })
        },
        // 通用商品详情
        getGeneralGoodsDetail(data) {
            return app.$requestApi({
                url: `/web-client/public/general_goods/details`,
                method: 'post',
                data
            })
        },
        // 通用商品套餐列表
        getGeneralGoodsSkuList(data) {
            return app.$requestApi({
                url: `/web-client/public/general_goods/sku/list`,
                method: 'get',
                data
            })
        },
        // 通用商品-卖家相关信息
        getGeneralSellerInfo(data) {
            return app.$requestApi({
                url: `/web-client/user/general_goods/seller-info`,
                method: 'get',
                data
            })
        },
        /** @通用商品 end **/
        // 商品配置属性对照表
        goodsListPropertyConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/listGoodsPropertyConfig',
                method: 'post',
                data
            })
        },
        // 客服列表
        listCustomerService(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/otherCustomerService',
                method: 'post',
                data
            })
        },
        // 客服列表
        listCustomerServicePublic(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listCustomerService',
                method: 'post',
                data
            })
        },
        // 游戏支持的商品类型
        listGoodsCatalogueBySearch(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listGoodsCatalogue',
                method: 'post',
                data
            })
        },
        // 商品配置属性对照表（区间搜索）
        listGoodsPropertyConfigBySearch(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/listGoodsPropertyConfig',
                method: 'post',
                data
            })
        },
        // 商品配置属性对照表（区间搜索）
        publicGameName(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/union/game/name',
                method: 'get',
                data
            })
        },

        // 商品配置属性对照表（区间搜索）
        goodsPublicUnionGameAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goods/property/config/options/union/game',
                method: 'post',
                data
            })
        },
        // 搜索选项（操作系统、区服筛选）
        listGoodsPropertyConfigOptionsBySearch(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/listGoodsPropertyConfigOptions',
                method: 'post',
                data
            })
        },
        // 脚本搜索选项（下拉框）
        listGoodsConfigScriptPropertyBySearch(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/listGoodsConfigScriptProperty',
                method: 'post',
                data
            })
        },
        // 区服树
        treeGameProperTiesBySearch(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/treeGameProperTies',
                method: 'post',
                data
            })
        },
        // 商品客服链接
        customerServiceConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/getCustomerServiceConfig',
                method: 'post',
                data
            })
        },
        // 交易须知
        listTradingNotice(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listTradingNotice',
                method: 'post',
                data
            })
        },
        // 用户咨询的商品列表
        pageUserConsultGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/userConsult/pageUserConsultGoods',
                method: 'post',
                data
            })
        },
        // 保存用户咨询商品
        saveUserConsultGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/userConsult/saveUserConsultGoods',
                method: 'post',
                data
            })
        },
        // 保存用户咨询商品-批量
        batchSaveUserConsultGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/userConsult/batchSaveUserConsultGoods',
                method: 'post',
                data
            })
        },
        // 删除用户咨询商品
        deleteUserConsultGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/userConsult/deleteUserConsultGoods',
                method: 'post',
                data
            })
        },
        // 砍价
        goodsKan(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/create/new',
                method: 'post',
                data
            })
        },
        // 砍价发起
        goodsKanNew(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/create/new',
                method: 'post',
                data
            })
        },
        // 我的砍价列表
        bargainMeList(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/buyer',
                method: 'post',
                data
            })
        },
        // 买家砍价列表
        bargainMeListv3(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/list',
                method: 'post',
                data
            })
        },
        // 砍价剩余次数及已有砍价价格及最低报价
        bargainCountAndPrice(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/count/and/price',
                method: 'post',
                data
            })
        },
        // 公共获取剩余砍价次数
        bargainCountConfig(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/common/get/bargain/count',
                method: 'post',
                data
            })
        },
        // 我的砍价列表导航栏
        listCounterAgree(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/listCounterAgree',
                method: 'post',
                data
            })
        },
        // 买家砍价列表
        bargainBuyerList(data) {
            return app.$requestApi({
                url: '/web-client/v2/counter/offer/quote/goods/page',
                method: 'post',
                data
            })
        },
        // 买家报价列表
        bargainBuyerOfferList(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/seller',
                method: 'post',
                data
            })
        },
        // 同意或者拒绝报价
        bargainBuyerReply(data) {
            return app.$requestApi({
                url: `/web-client/v2/${data.action.agreeStatus === 'SELLER_REFUSE' ? '/bargain/refuse' : '/bargain/agree'}`,
                method: 'post',
                data
            })
        },
        // 还价
        bargainCounter(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/counter',
                method: 'post',
                data
            })
        },
        // 取消砍价
        bargainCancelBargain(data) {
            return app.$requestApi({
                url: '/web-client/v2/cancelBargain',
                method: 'post',
                data
            })
        },
        // 卖家取消砍价
        sellerBargainCancelBargain(data) {
            return app.$requestApi({
                url: '/web-client/v2/seller/cancelBargain',
                method: 'post',
                data
            })
        },
        // 同意还价
        buyerAgreeBargain(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/buyerAgree',
                method: 'post',
                data
            })
        },
        // 获取发布商品联系方式
        getUserLinkMessage(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/getUserLinkMessage',
                method: 'post',
                data
            })
        },
        // 用户是否砍价
        bargainGoodsStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/bargain/goods/userStatus',
                method: 'post',
                data
            })
        },
        // 已有砍价价格 null-则没有
        bargainPrice(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/price',
                method: 'post',
                data
            })
        },
        // 获取banner
        getBannerList(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/banner/goods',
                method: 'post',
                data
            })
        },
        // 每日成交统计数据
        dayTransaction(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/dayTransaction',
                method: 'post',
                data
            })
        },
        // 获取oss配置
        stsAuth(data) {
            return app.$requestApi({
                url: '/web-client/v2/sts/auth',
                method: 'post',
                data
            })
        },
        // 配置
        publicConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/other/config',
                method: 'post',
                data
            })
        },
        // 发送短信
        sendSms(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/common/sms',
                method: 'post',
                data
            })
        },
        // banner
        bannerList(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/banner/list',
                method: 'post',
                data
            })
        },
        // 首页统计
        transactionStatistics(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/transaction/statistics',
                method: 'post',
                data
            })
        },
        // 客服验证、黑号查询
        checkNumber(data) {
            return app.$requestApi({
                url: `/web-client/v2/homepage/public/${data.action.type === 'blackNumber' ? 'blacklist' : 'customer'}/check`,
                method: 'post',
                data
            })
        },
        // 新闻公告列表
        newsPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/news/page',
                method: 'post',
                data
            })
        },
        // 新闻公告详情
        newsPageDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/news/detail',
                method: 'post',
                data
            })
        },
        // 问题列表
        questionList(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/question/list',
                method: 'post',
                data
            })
        },
        // 新问题列表
        questionListNew(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/question/list_new',
                method: 'post',
                data
            })
        },
        // 问题详情
        questionDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/question/detail',
                method: 'post',
                data
            })
        },
        // 有无帮助
        isHelp(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/question/help',
                method: 'post',
                data
            })
        },
        // 首页问题列表
        questionPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/question/page',
                method: 'post',
                data
            })
        },
        // 主播
        anchorPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/anchor/page',
                method: 'post',
                data
            })
        },
        // 主播跳转次数
        anchorAddNumber(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/anchor/add/number',
                method: 'post',
                data
            })
        },
        // 垫付分期
        stagesBuyContent(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/stages/buy/main/get',
                method: 'post',
                data
            })
        },
        // 首付下拉框
        getStagesBuyFirstPayGet(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/stages/buy/first/pay/list',
                method: 'post',
                data
            })
        },
        // 获取分期数下拉框
        getStagesBuyList(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/stages/buy/stages/list',
                method: 'post',
                data
            })
        },
        // 获取每期还款价格
        getStagesBuyPriceList(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/stages/buy/stages/price/list',
                method: 'post',
                data
            })
        },
        // 中介担保交易客服列表
        guaranteeServiceList(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/guarantee/list',
                method: 'post',
                data
            })
        },
        // 文章详情
        articleDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/article',
                method: 'post',
                data
            })
        },
        // 最新成交
        transactionNew(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/transaction/new',
                method: 'post',
                data
            })
        },
        // 联系我们客服列表
        contactUsList(data) {
            return app.$requestApi({
                url: '/web-client/v2/introduce/public/contact/us/list',
                method: 'post',
                data
            })
        },
        // 反馈类型列表
        suggestionTypeList(data) {
            return app.$requestApi({
                url: '/web-client/v2/suggestion/public/type/list',
                method: 'post',
                data
            })
        },
        // 提交反馈
        suggestionSava(data) {
            return app.$requestApi({
                url: '/web-client/v2/suggestion/save',
                method: 'post',
                data
            })
        },
        // 新闻公告
        listNewsPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/news/page',
                method: 'post',
                data
            })
        },
        // 新闻公告详情
        listNewsDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/news/detail',
                method: 'post',
                data
            })
        },
        // app下载地址
        appUrl(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/common/app/url',
                method: 'post',
                data
            })
        },
        // 消息列表
        messagePage(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/message/page',
                method: 'post',
                data
            })
        },
        // 未读消息
        messageUnreadNumber(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/message/unread/number',
                method: 'post',
                data
            })
        },
        // 收藏角标消息
        messageUnreadCollection(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/collect/goods/alert/read',
                method: 'get',
                data
            })
        },
        // 读消息
        messageRead(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/message/read',
                method: 'post',
                data
            })
        },
        // 读全部消息
        messageReadAll(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/message/read/all',
                method: 'post',
                data
            })
        },
        // 业务介绍
        businessList(data) {
            return app.$requestApi({
                url: '/web-client/v2/introduce/public/business/list',
                method: 'post',
                data
            })
        },
        // 公司介绍
        companyList(data) {
            return app.$requestApi({
                url: '/web-client/v2/introduce/public/company/list',
                method: 'post',
                data
            })
        },
        // 招贤纳士二维码
        qrJobInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/job/contact/get',
                method: 'post',
                data
            })
        },
        // 职业列表
        jobPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/job/base/page',
                method: 'post',
                data
            })
        },
        // 职业detail
        jobDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/job/detail',
                method: 'post',
                data
            })
        },
        // 简历模板
        jobResumeTemplate(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/job/template/get',
                method: 'post',
                data
            })
        },
        // 投递
        jobNotice(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/job/notice/get',
                method: 'post',
                data
            })
        },
        // 弹窗客服列表
        contactList(data) {
            return app.$requestApi({
                url: '/web-client/v2/introduce/public/contact/us/list',
                method: 'post',
                data
            })
        },

        // 通过游戏ID获取客服列表
        customerList(data) {
            return app.$requestApi({
                url: `/web-client/v2/${data.action.linkType ? '/public/game/customer/fistMerchant' : '/public/game/customer/list'}`,
                method: 'post',
                data
            })
        },
        // 相关监测事件点击次数增加 埋点
        getRelatedClicks(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/monitor/hit',
                method: 'post',
                data
            })
        },
        // 回收-号商列表-咨询客服 埋点
        getConsultationMonitorHit(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/consultation/monitor/hit',
                method: 'post',
                data
            })
        },
        // 1.添加链接流量统计
        flowUrlAdd(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/marketing/url/flow/add',
                method: 'post',
                data
            })
        },
        // 1.添加链接流量统计
        customerService(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/feed/customerService',
                method: 'post',
                data
            })
        },
        // 发送短信
        sedSms2(data) {
            return app.$requestApi({
                url: '/web-client/v2/common/sms',
                method: 'post',
                data
            })
        },
        // 发送短信
        sedSms(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/common/sms',
                method: 'post',
                data
            })
        },
        // 登录
        login(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/login/password',
                method: 'post',
                data
            })
        },
        // 第三方登录
        thirdLogin(data) {
            return app.$requestApi({
                url: '/web-client/v2/third-login',
                method: 'post',
                data
            })
        },
        // 手机登录
        codeLogin(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/login/phone',
                method: 'post',
                data
            })
        },
        // 退出
        logout(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/logout',
                method: 'post',
                data
            })
        },
        // 注册
        register(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/register',
                method: 'post',
                data
            })
        },
        // 忘记密码
        forgetPassword(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/password/forget',
                method: 'post',
                data
            })
        },
        // 第三方登录：绑定手机号
        bindingMobile(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/login/third/binding/mobile',
                method: 'post',
                data
            })
        },
        // 三方登录:QQ或者微信-授权,返回userId和是否绑定手机号
        thirdGrant(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/login/third/auth',
                method: 'post',
                data
            })
        },
        // 检查手机号码是否被注册
        mobileCheck(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/mobile/check',
                method: 'post',
                data
            })
        },

        // 获取融云token
        getImInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/rim/info',
                method: 'post',
                data
            })
        },
        // 充值
        payRecharge(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/recharge',
                method: 'post',
                data
            })
        },
        // 充值状态轮询
        getPayStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/recharge/query',
                method: 'post',
                data
            })
        },
        // 砍价支付
        bargainPay(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/pay',
                method: 'post',
                data
            })
        },
        // 砍价状态轮询
        queryBargainOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/query/bargain',
                method: 'post',
                data
            })
        },
        // 用户信息
        getUserInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/login/info',
                method: 'post',
                data
            })
        },
        // 账户详情
        getAccountInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/login/third/binding/mobile',
                method: 'post',
                data
            })
        },
        // 个人中心统计
        userCenterStatistics(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/center/statistics',
                method: 'post',
                data
            })
        },
        // 设置支付密码
        setUserPayPassword(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/password/set',
                method: 'post',
                data
            })
        },
        // 修改用户信息
        modUserInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/info/mod',
                method: 'post',
                data
            })
        },
        // 微信解绑
        unbindWx(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/third/auth/unbind',
                method: 'post',
                data
            })
        },
        // 获取支付宝账户
        getAlipayAccount(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/alipay/get',
                method: 'post',
                data
            })
        },
        // 识别身份证
        userOcrIdCard(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/common/ocr/id/card',
                method: 'post',
                data
            })
        },
        // 提现列表
        withdrawPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/withdraw/page',
                method: 'post',
                data
            })
        },
        // 提现详情
        withdrawDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/withdraw/detail',
                method: 'post',
                data
            })
        },
        // 明细列表
        recordList(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/record',
                method: 'post',
                data
            })
        },
        // 提现账户
        accountAlipay(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/alipay/get',
                method: 'post',
                data
            })
        },
        // 申请提现
        withdrawApply(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/withdraw/apply',
                method: 'post',
                data
            })
        },
        // 提现手续费
        withdrawFee(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/withdraw/fee',
                method: 'post',
                data
            })
        },
        // 解绑支付宝
        unbindAlipay(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/alipay/unbind',
                method: 'post',
                data
            })
        },
        // 绑支付宝
        bindAlipay(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/alipay/bind',
                method: 'post',
                data
            })
        },
        // 检查支付密码是否设置
        checkAccountWhetherSetPayPass(data) {
            return app.$requestApi({
                url: '/web-client/v2/account/password/whether',
                method: 'post',
                data
            })
        },
        // 用户实名认证
        userCertify(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/aliyun/userCertify',
                method: 'post',
                data
            })
        },
        // 实名认证结果
        queryUserCertify(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/aliyun/certify/query',
                method: 'post',
                data
            })
        },
        // 第三方
        thirdUrl(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/login/third',
                method: 'post',
                data
            })
        },
        // 微信公众号二维码
        getBindingQrCodeUrl(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/center/getBindingQrCodeUrl',
                method: 'post',
                data
            })
        },
        // 第三方实名
        newCertify(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/certify/create',
                method: 'post',
                data
            })
        },
        // 实名轮询
        queryCertify(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/certify/query',
                method: 'post',
                data
            })
        },
        // 获取联系方式
        userLink(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/link',
                method: 'post',
                data
            })
        },
        // 保存联系方式
        userLinkSave(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/link/save',
                method: 'post',
                data
            })
        },
        // 修改回收是否取消其它商品报价状态
        bargainUpdate(data) {
            return app.$requestApi({
                url: '/web-client/v2/bargain/status/update',
                method: 'post',
                data
            })
        },
        // 更改用户电话号码
        changePhone(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/changePhone',
                method: 'post',
                data
            })
        },
        // 回收中心列表
        reGoodsPage(data) {
            return app.$requestApi({
                url: '/merchant/recycle/recyclePage',
                method: 'post',
                data
            })
        },
        // 新增回收商品
        saveReGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/saveRecoveryGoods',
                method: 'post',
                data
            })
        },
        // 回收商品详情
        reGoodsDetail(data) {
            return app.$requestApi({
                url: '/merchant/recycle/detail',
                method: 'get',
                data
            })
        },
        // 用户同意报价
        agreeRecycleQuote(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/recycle/agreeRecycleQuote/' + data,
                method: 'post'
            })
        },
        // 用户取消回收
        cancelRecycleQuote(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/recycle/cancelRecycleGoods/' + data,
                method: 'post'
            })
        },
        // 商家回收商品报价相关查询
        reBusinessquoteRecord(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/quoteRecord',
                method: 'post',
                data
            })
        },

        // 商品详情(商家)
        reGoodsDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/goodsDetails',
                method: 'post',
                data
            })
        },
        // 商家直接回收
        buyReGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/buyRecycleGoods/' + data,
                method: 'post'
            })
        },
        // 报价
        addRecycleQuote(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/addRecycleQuote',
                method: 'post',
                data
            })
        },
        // 竞价商品列表
        reBusinessPage(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/goods/page',
                method: 'post',
                data
            })
        },
        // 回收配置
        recycleConfigList(data) {
            return app.$requestApi({
                url: '/web-client/v2/bidder/recycle/recycleConfigList',
                method: 'post',
                data
            })
        },
        // 黑名单查询
        checkRecoveryUserBlacklist() {
            return app.$requestApi({
                url: '/web-client/v2/user/recycle/checkRecoveryUserBlacklist',
                method: 'post'
            })
        },
        // 手续费查询
        getReChargeFee(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/recycle/fee',
                method: 'post',
                data
            })
        },
        // ----------------------- 游戏资讯 ------------------------
        // 游戏资讯列表
        informationListAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcArticlePage/new',
                method: 'post',
                data
            })
        },
        // 最热文章
        articleHotAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/hot',
                method: 'post',
                data
            })
        },
        // 最新文章
        articleNewAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/new',
                method: 'post',
                data
            })
        },
        // 获取资讯文章详情上一篇
        articleLastAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcArticleLast/new',
                method: 'post',
                data
            })
        },
        // 获取资讯文章详情下一篇
        articleNextAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcArticleNext/new',
                method: 'post',
                data
            })
        },
        // 推荐文章
        recommendedArticlesAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcRecommend/new',
                method: 'post',
                data
            })
        },
        // 内链管理
        innersAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/inners',
                method: 'post',
                data
            })
        },
        // 热门账号
        pcPopularAccountsAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcPopularAccounts/new',
                method: 'post',
                data
            })
        },
        // 文章详情
        articleDetailsAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/pcArticleDetail/new',
                method: 'post',
                data
            })
        },
        // 获取资讯文章类型列表
        listArticleTypesAPI(data) {
            return app.$requestApi({
                url: '/content/public/article/typeList',
                method: 'post',
                data
            })
        },
        // 全部游戏，第一个游戏有顶级账号列表（解决前端渲染效率的问题）
        getAllTopGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/all/topGoods',
                method: 'post',
                data
            })
        },
        // 获取IM用户头像和昵称
        findUsers(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/findUsers',
                method: 'post',
                data
            })
        },
        // 批量获取群信息（IM）
        findGroups(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/findGroups',
                method: 'post',
                data
            })
        },
        // 获取群消息
        findGroup(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/group',
                method: 'post',
                data
            })
        },
        // 获取群消息
        findGroupMessage(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/chat/specification/reminders',
                method: 'post',
                data
            })
        },
        // 获取群消息
        goodsDetailByGroup(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/goods/detail/by/group',
                method: 'post',
                data
            })
        },
        // 计算佣金
        calculateCommission(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/calculate/commission',
                method: 'post',
                data
            })
        },
        // 查看名片
        getCsCard(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/csCard/' + data,
                method: 'get'
            })
        },
        // 获得客服自动回复内容
        getCsAuto(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/csAuto/send',
                method: 'post',
                data
            })
        },
        // 用户咨询获得客服信息
        getCustomerService(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/getCustomerService',
                method: 'post',
                data
            })
        },
        // 商品管理-用户咨询获得客服信息
        getGoodsCustomerService(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/get/goods/customer/service',
                method: 'post',
                data
            })
        },
        getIndex() {
            return app.$requestApi({
                url: _LOCAL_URL + '/index',
                method: 'post'
            })
        },
        // im客服列表
        getImList(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/imList',
                method: 'post',
                data
            })
        },
        // 获取IMId
        findIm(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/allot/complainCustomerService',
                method: 'get',
                data
            })
        },
        // 中介担保客服列表(IM版)
        guarantee() {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/guarantee',
                method: 'get'
            })
        },
        // 获取反馈投诉建议客服列表(IM版)
        feed() {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/feed',
                method: 'get'
            })
        },
        // 获得一个回收号商客服
        fistMerchant(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/fistMerchant',
                method: 'post',
                data
            })
        },
        // 页面访问记录(埋点)
        pageTracking(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/tracking/add',
                method: 'post',
                data
            })
        },
        // 用户实名认证 2023.2.28
        userAuthVerify(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/elementSmartVerify',
                method: 'post',
                data
            })
        },
        // 4.0.6 姓名和身份证验证
        // userOnlyElementSmartVerify(data) {
        // 	return app.$requestApi({
        // 		url: '/web-client/v2/user/only/elementSmartVerify',
        // 		method: 'post',
        // 		data
        // 	})
        // },
        // 获取人脸认证信息 2023.2.28
        getFaceAuth(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/aliyun/getAliCertifyInfo',
                method: 'post',
                data
            })
        },
        // 获取人脸认证凭证信息&二要素信息认证 仅作认证
        getOnlyFaceAuth(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/only/aliyun/getAliCertifyInfo',
                method: 'post',
                data
            })
        },
        // 获取人脸认证结果 2023.2.28
        checkFaceAuth(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/aliyun/face/certify/query',
                method: 'post',
                data
            })
        },
        // 获取实名认证帮助客服
        getAuthService(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/getRealNameCs',
                method: 'post',
                data
            })
        },
        // 添加热点词组数据
        addPublic(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/add',
                method: 'post',
                data
            })
        },
        // 添加热点词组数据
        getOrderFlow(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/orderFlow',
                method: 'get',
                data
            })
        },
        // 获取售后客服新信息
        getAfterSalesImInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/getAfterSalesImInfo',
                method: 'post',
                data
            })
        },
        // ---------------Im创建群聊---------------------
        // 根据手机号查找用户IM信息
        userFindUsersByPhone(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/findUsersByPhone',
                method: 'post',
                data
            })
        },
        // 创建群
        userCreateGroup(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/createGroup',
                method: 'post',
                data
            })
        },
        // 根据会话id查询订单
        getGroupBuyerOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/buyerOrder',
                method: 'get',
                data
            })
        },
        // 查询数据来源详情
        accountSourceDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/accountSource/detail',
                method: 'post',
                data
            })
        },
        // 提交数据来源
        accountSourceCommit(data) {
            return app.$requestApi({
                url: '/web-client/v2/accountSource/commit',
                method: 'post',
                data
            })
        },
        // 提交IM表单
        formataSubmit(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/form-data-submit',
                method: 'post',
                data
            })
        },
        // 提交卖家个人信息收集
        groupPaymentInformation(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/payment/information',
                method: 'post',
                data
            })
        },
        // 提交买家家个人信息收集
        groupOrderBuyerInfoCollect(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/order/buyerInfo/collect',
                method: 'post',
                data
            })
        },
        // 提交买卖家付款信息
        groupCancelPaymentInformation(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/cancel/payment/information',
                method: 'post',
                data
            })
        },
        // 获取提交信息的回显
        groupGetPaymentInformation(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/get/payment/information',
                method: 'get',
                data
            })
        },
        // 校验im异常表单提交token有效性
        commonsPublicIdToken(data) {
            return app.$requestApi({
                url: '/commons/public/idempotent/token-check',
                method: 'post',
                data
            })
        },
        //  ----------------2.4.0 迭代相关接口-------------------
        // 中介订单详情
        getAgencyOrderInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/agency/order/info/get',
                method: 'post',
                data
            })
        },
        // 买卖家确认中介订单信息
        confirmAgencyOrderInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/agency/order/info/confirm',
                method: 'post',
                data
            })
        },
        // 在线支付
        // 计算意向金-定金
        createOrderCalculateFee(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/calculate/earnest/fee',
                method: 'get',
                data
            })
        },
        // 包赔下拉详情
        createOrderCompensationList(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/bargain/compensation/service/detail/list',
                method: 'post',
                data
            })
        },
        // 创建订单(2.0)
        createOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/order/create',
                method: 'post',
                data
            })
        },
        // 支付宝PC二维码在线支付-意向金
        paymentArousalQrCode(data) {
            return app.$requestApi({
                // url: '/web-client/v2/payment/arousal/qrCode',
                url: '/web-client/v2/payment/pay',
                method: 'post',
                data
            })
        },
        // 客服介入
        serviceIntervene(data) {
            return app.$requestApi({
                url: '/workorder/general/order/official/service/intervene',
                method: 'post',
                data
            })
        },
        // 待支付查询详情
        getParOrderDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/online/order/detail',
                method: 'post',
                data
            })
        },
        // 查询支付回调
        getParOrderSuccess(data) {
            return app.$requestApi({
                url: '/web-client/v2/payment/arousal/query/pay/success',
                method: 'post',
                data
            })
        },
        // 根据订单编号获取对应客服id
        getOrderCustomerService(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/get/customer/service',
                method: 'get',
                data
            })
        },
        // 取消在线订单
        getOrderCancelOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/cancel/online/order',
                method: 'get',
                data
            })
        },
        // 检查商品是否可操作
        getCheckGoodsStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/check/goods/status',
                method: 'get',
                data
            })
        },
        // 检查订单是否可操作
        getCheckOrderStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/check/order/status',
                method: 'get',
                data
            })
        },
        // 查询商品是走线上还是线下
        getTradeTypeGet(data) {
            return app.$requestApi({
                url: '/web-client/v2/tradeType/get',
                method: 'post',
                data
            })
        },
        // 获取砍价须知内容
        getHagglingDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/haggling/detail',
                method: 'post',
                data
            })
        },
        // 获取账号源列表
        getAccountSourceList(data) {
            return app.$requestApi({
                url: '/web-client/v2/accountSource/list',
                method: 'post',
                data
            })
        },
        // 获取发布商品前置扫码
        userCenterGetQrCode(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/getQrCode',
                method: 'post',
                data
            })
        },
        // 轮询获取二维码状态 goodsRequestId
        userCenterQrCodeStatus(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/qrCode/status',
                method: 'get',
                data
            })
        },
        // 获取游戏三方截图方式
        userCenterGetThridShotType(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/getThridShotType',
                method: 'post',
                data
            })
        },
        // 三方截图任务提交
        thirdTaskStartApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/task/start',
                method: 'post',
                data
            })
        },
        // 三方截图任务提交
        thirdTaskStartStatusApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/script/task/status',
                method: 'get',
                data
            })
        },
        // 小算前置提交账密
        xiaosuanCommit(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/xiaosuan/auth/commit',
                method: 'post',
                data
            })
        },
        // 轮询获取小算认证结果 goodsRequestId
        xiaosuanResult(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/xiaosuan/auth/result',
                method: 'get',
                data
            })
        },
        // 小算提交验证码
        xiaosuanCodeCommit(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/xiaosuan/code/commit',
                method: 'post',
                data
            })
        },
        // 提交自动化截图验证码
        shotVerifyCodeAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/script/verify/code',
                method: 'post',
                data
            })
        },
        // 商品直接改价
        goodsModifyPrice(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goods/modify/price',
                method: 'post',
                data
            })
        },
        // 商品多选批量改价
        goodsBatchModifyPrice(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goods/batch/modify/price',
                method: 'post',
                data
            })
        },
        // 商品全部改价
        goodsAllModifyPrice(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goods/all/modify/price',
                method: 'post',
                data
            })
        },
        // 根据商品编号查询商品信息(用于前端检索商品用,支持批量查询)
        esRetrieveGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/es/retrieve/goods',
                method: 'post',
                data
            })
        },
        // 个人中心商品批量改价列表
        batchPricePageGoods(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/batch/modify/price/pageGoods',
                method: 'post',
                data
            })
        },
        // 商品卡片常用咨询 点击自动发消息
        goodsCardBuyerMessage(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/buyerMessage',
                method: 'post',
                data
            })
        },
        // 商品卡片常用咨询 获取标签输入类型、值
        getGoodsCardLabelType(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/inputDetail',
                method: 'get',
                data
            })
        },
        // 商品卡片常用咨询 获取标签输入类型、值
        getGoodsCardLabelSubmit(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/submit',
                method: 'post',
                data
            })
        },
        // 小算-前置校验黑号-重复账号
        userCenterGoodsCheck(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goods/check',
                method: 'post',
                data
            })
        },
        // 小算-任务提交
        thirdShotTaskStart(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/task/start',
                method: 'post',
                data
            })
        },
        // 小算-修改账密
        thirdShotPasswordUpdate(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/password/update',
                method: 'post',
                data
            })
        },
        // 根据售后类型获取前置问题列表
        afterSalesPreposeListBypermissionId(data) {
            return app.$requestApi({
                url: '/web-client/v2/afterSales/order/preposeListBypermissionId',
                method: 'post',
                data
            })
        },
        // 支付宝PC二维码在线支付 2.0-尾款-全款
        paymentArousalBalanceQrCode(data) {
            return app.$requestApi({
                url: '/web-client/v2/payment/arousal/balance/qrCode',
                method: 'post',
                data
            })
        },
        // 发送客服下班话术给当前用户
        usercsWorkAutoSend(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/csWorkAuto/send',
                method: 'post',
                data
            })
        },
        // 新版计算费率
        getFeeNew(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/transactionFee/list',
                method: 'post',
                data
            })
        },
        // 小算SDK结果上报
        sdkResultCommit(data) {
            return app.$requestApi({
                url: '/web-client/v2/third/shot/sdk/verify/result/commit',
                method: 'post',
                data
            })
        },
        // 订单列表(已购买-已取消)
        orderListNew(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/order/page/new',
                method: 'post',
                data
            })
        },
        // 工单-获取动态表单
        workorderCardFormData(data) {
            return app.$requestApi({
                url: '/workorder/card/form/data',
                method: 'post',
                data
            })
        },
        // 工单-动态表单提交
        workorderCardButtonSubmit(data) {
            return app.$requestApi({
                url: '/workorder/card/button/submit',
                method: 'post',
                data
            })
        },
        submitSupplementCompensationApi(data) {
            return app.$requestApi({
                url: '/workorder/seller/supplement/compensation',
                method: 'post',
                data
            })
        },
        // 卖家中心订单列表
        userCenterSellerOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/seller/order/page',
                method: 'post',
                data
            })
        },
        // 工单-卖家校验收款账户
        workorderCheckPaymentAccount(data) {
            return app.$requestApi({
                url: '/workorder/check/payment/account',
                method: 'post',
                data
            })
        },
        // 工单-查询收款账户及真实姓名
        workorderGetPaymentAccount(data) {
            return app.$requestApi({
                url: '/workorder/get/payment/account',
                method: 'get',
                data
            })
        },
        // 工单-交易取消,买家提供收款账户
        workorderBuyerSubmitPaymentAccount(data) {
            return app.$requestApi({
                url: '/workorder/buyer/submit/payment/account',
                method: 'post',
                data
            })
        },
        // 工单-账户收款失败，重新绑定账户
        workorderPayAccountBind(data) {
            return app.$requestApi({
                url: '/workorder/pay/account/bind',
                method: 'post',
                data
            })
        },
        // 工单-根据群聊ID获取工单最新卡片
        workorderGetTicketCards(data) {
            return app.$requestApi({
                url: '/workorder/get/ticket/progress/latest/cards',
                method: 'get',
                data
            })
        },
        // 创建砍价订单
        createBargainOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/create/for/bargain/new',
                method: 'post',
                data
            })
        },
        // 创建全款订单
        fullOrderCreate(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/create',
                method: 'post',
                data
            })
        },
        // 工单-3.0 订单扭转信息
        workorderOrderProcess(data) {
            return app.$requestApi({
                url: '/workorder/order/process',
                method: 'get',
                data
            })
        },
        // 工单- 获取工单卡片配置信息
        workorderGetTicketProgressCrad(data) {
            return app.$requestApi({
                url: '/workorder/get/ticket/node/config/info',
                method: 'get',
                data
            })
        },
        // 根据游戏获取工单模板id
        checkWorkorderTemplate(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/workorder/template',
                method: 'get',
                data
            })
        },
        // 通用支付接口 (支付违约金)
        paymentPay(data) {
            return app.$requestApi({
                url: '/web-client/v2/payment/pay',
                method: 'post',
                data
            })
        },
        // 同意加入推广小组
        agreeJoinGroup(data) {
            return app.$requestApi({
                url: '/activity/benefit/join/group/deal',
                method: 'post',
                data
            })
        },
        // 查询支付状态 (支付违约金、放心购轮询)
        paymentQueryPay(data) {
            return app.$requestApi({
                url: '/web-client/v2/payment/query/pay/status',
                method: 'post',
                data
            })
        },
        // 卖家已取消详情
        orderSellerDetails(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/seller/order/detail',
                method: 'get',
                data
            })
        },
        // 同意报价
        quotedAgree(data) {
            return app.$requestApi({
                url: '/merchant/recycle/quoted/agree',
                method: 'get',
                data
            })
        },
        // 卖家删除回收单
        quotedDelete(data) {
            return app.$requestApi({
                url: '/merchant/recycle/delete',
                method: 'get',
                data
            })
        },
        // 获取专属维护客服
        getMaintenanceCustomerVO(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/getMaintenanceCustomerVO',
                method: 'get',
                data
            })
        },
        // 获取报价单最新报价
        quoteLatestPrice(data) {
            return app.$requestApi({
                url: '/merchant/recycle/recycle/cost',
                method: 'get',
                data
            })
        },
        // 1_2.获取商品列表banner(新版)
        bannerGoodsMore(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/banner/goods/more',
                method: 'post',
                data
            })
        },
        // 获取banner详情
        bannerDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/banner/detail',
                method: 'post',
                data
            })
        },
        // 当前用户活动身份( 邀约人 or 受邀人 or 未绑定)
        inviteeUserType(data) {
            return app.$requestApi({
                url: '/activity/acb/user/ac/type',
                method: 'post',
                data
            })
        },
        // 分佣活动受邀人邀请码绑定邀请人
        acbInviteeBind(data) {
            return app.$requestApi({
                url: '/activity/acb/invitee/bind',
                method: 'get',
                data
            })
        },
        // C端用户裂变活动参与绑定并生成口令API
        accInviterShibboleth(data) {
            return app.$requestApi({
                url: '/activity/acc/inviter/shibboleth',
                method: 'post',
                data
            })
        },
        // 裂变活动受邀人邀请码绑定邀请人
        accInviteeBind(data) {
            return app.$requestApi({
                url: '/activity/acc/invitee/bind',
                method: 'get',
                data
            })
        },
        // 引流分佣活动详情
        acbDetails(data) {
            return app.$requestApi({
                url: '/activity/user/case/details',
                method: 'get',
                data
            })
        },
        // 引流分佣获取口令
        acbTemplateContent(data) {
            return app.$requestApi({
                url: '/activity/user/case/template/content',
                method: 'get',
                data
            })
        },
        // “引流分佣活动” 分佣金额
        acbBrokerageAmount(data) {
            return app.$requestApi({
                url: '/activity/info/acb/brokerage/amount',
                method: 'post',
                data
            })
        },
        // “引流分佣活动” 我的邀请
        acbInviteeList(data) {
            return app.$requestApi({
                url: '/activity/info/acb/invitee/list',
                method: 'post',
                data
            })
        },
        // 裂变活动详情
        accDetails(data) {
            return app.$requestApi({
                url: '/activity/info/acc/detail',
                method: 'post',
                data
            })
        },
        // “活动受邀用户” 裂变活动奖励
        accInviteeAward(data) {
            return app.$requestApi({
                url: '/activity/info/acc/invitee/award',
                method: 'post',
                data
            })
        },
        // “裂变活动” 我的邀请
        accInviteeList(data) {
            return app.$requestApi({
                url: '/activity/info/acc/invitee/list',
                method: 'post',
                data
            })
        },
        // ”邀请发起用户“ 裂变活动奖励
        accInviterAward(data) {
            return app.$requestApi({
                url: '/activity/info/acc/inviter/award',
                method: 'post',
                data
            })
        },
        // 咨询评价-查询是否评价
        questionnaireConsultIsEvaluate(data) {
            return app.$requestApi({
                url: '/activity/questionnaire/consult-is-evaluate',
                method: 'get',
                data
            })
        },
        // 咨询评价-提交
        questionnaireConsultSubmit(data) {
            return app.$requestApi({
                url: '/activity/questionnaire/consult-submit',
                method: 'post',
                data
            })
        },
        // 交易-商品问卷-获取问卷详情
        questionnaireDetail(data) {
            return app.$requestApi({
                url: '/activity/questionnaire/detail',
                method: 'get',
                data
            })
        },
        // 交易-商品问卷-提交
        questionnaireSubmit(data) {
            return app.$requestApi({
                url: '/activity/questionnaire/submit',
                method: 'post',
                data
            })
        },
        // 查询收款账户及真实姓名(卖家收款账户校验)
        sellerPaymentAccount(data) {
            return app.$requestApi({
                url: '/workorder/get/seller/payment/account',
                method: 'post',
                data
            })
        },
        // 查询游戏配置-放心购
        userCenterGameConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/game/config',
                method: 'post',
                data
            })
        },
        // 服务订单列表
        serveOrderList(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/page',
                method: 'post',
                data
            })
        },
        // 服务订单用户主动取消
        serveOrderCancel(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/cancel',
                method: 'post',
                data
            })
        },
        // 服务订单详情接口
        serveOrderDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/get',
                method: 'get',
                data
            })
        },
        // 服务订单退款
        serveOrderRefund(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/refund',
                method: 'post',
                data
            })
        },
        // 服务订单创建
        serveOrderCreate(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/create',
                method: 'post',
                data
            })
        },
        // 卖家根据游戏id获取回收号商列表
        recyclePermissionList(gameId) {
            return app.$requestApi({
                url: '/merchant/mer/recycle/permission/list',
                method: 'get',
                data: {
                    gameId
                }
            })
        },
        // 卖家咨询号商
        recycleConsult(data) {
            return app.$requestApi({
                // 号商需求回滚
                url: '/merchant/mer/recycle/consult',
                // url: '/merchant/mer/recycle/game/consult',
                method: 'post',
                data
            })
        },
        // 卖家获取可回收的游戏
        recycleGameList(data) {
            return app.$requestApi({
                url: '/merchant/mer/recycle/game/list',
                method: 'post',
                data
            })
        },
        // 埋点批量事件
        monitorHitBatch(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/monitor/hit/batch',
                method: 'post',
                data
            })
        },
        // 用户方便交易时间编辑
        userTimeEdit(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/public/easy/trade/time/edit',
                method: 'post',
                data
            })
        },
        // 获取全局配置
        sysGetConfig(data) {
            return app.$requestApi({
                url: '/web-client/v2/sys/public/get/config',
                method: 'get',
                data
            })
        },
        // 我咨询的列表
        getConsultLabelBuyerList(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/get/consulted/products/buyer',
                method: 'post',
                data
            })
        },
        // 我咨询的详情
        getConsultLabelBuyerInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/get/consulted/products/info',
                method: 'get',
                data
            })
        },
        // 咨询我的列表
        getConsultLabelSellerList(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/get/consulted/products/seller',
                method: 'post',
                data
            })
        },
        // 咨询我的详情
        getConsultLabelSellerInfo(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/reply/detail',
                method: 'get',
                data
            })
        },
        // 咨询我的提交
        getConsultLabelSellerSubmit(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/batch/submit',
                method: 'post',
                data
            })
        },
        // 特殊埋点公共接口
        commonsMonitorHit(data) {
            return app.$requestApi({
                url: '/commons/monitor/business/public/hit',
                method: 'post',
                data
            })
        },
        // 提交收款信息-中介取消订单
        getCancelPaymentInformationAgency(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/cancel/payment/information/agency',
                method: 'post',
                data
            })
        },
        // 服务器时间
        serverTime(data) {
            return app.$requestApi({
                url: '/server/time',
                method: 'get',
                data
            })
        },
        // 商品放心购退款
        assuredBuyRefund(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/confidence/buy/refund',
                method: 'post',
                data
            })
        },
        // 联系电话安全认证
        checkLinkPhone(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/link/phone/check',
                method: 'post',
                data
            })
        },

        // im创建指定价格订单-检查
        checkOrderStatusByFictitiousOrderId(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/check/order/status',
                method: 'get',
                data
            })
        },
        // 订单修改后商品价格
        orderUpdatePriceAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/query/goods/orderUpdatePrice',
                method: 'post',
                data
            })
        },
        // im创建指定价格订单-创建
        createFictitiousOrder(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/create',
                method: 'post',
                data
            })
        },
        // 获得一个回收号商客服
        fistMerchant(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/game/customer/fistMerchant',
                method: 'post',
                data
            })
        },
        // 服务器时间
        testCode(data) {
            return app.$requestApi({
                url: '/test/code',
                method: 'get',
                data
            })
        },
        // 获取优惠券分组数量
        getMyActivityCouponCount(data) {
            return app.$requestApi({
                url: '/activity/coupon/my/counter',
                method: 'post',
                data
            })
        },
        // 获取分组优惠券列表
        getMyActivityCouponList(data) {
            return app.$requestApi({
                url: '/activity/coupon/my/pageList',
                method: 'post',
                data
            })
        },
        // 下单前获取所有可用优惠券列表
        getWaitUseCouponList(data) {
            return app.$requestApi({
                url: '/activity/coupon/wait/select/list',
                method: 'post',
                data
            })
        },
        // 用户订单取消限制校验
        checkOrderLimit(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/order/cancel/limit/check',
                method: 'post',
                data
            })
        },
        // 查询支付方式
        payType(data) {
            return app.$requestApi({
                url: '/web-client/v2/payment/query/pay/type',
                method: 'post',
                data
            })
        },
        // 获取卖家砍价列表数据 2024-08-14  4.0.8-2 迭代
        getBargainSellerList(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/list',
                method: 'post',
                data
            })
        },
        // 卖家结束砍价
        cancelBargainSellerApi(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/cancel',
                method: 'post',
                data
            })
        },
        // 卖家拒绝砍价
        refuseBargainSellerApi(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/refuse',
                method: 'post',
                data
            })
        },
        // 卖家还价
        counterBargainSellerApi(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/counter',
                method: 'post',
                data
            })
        },
        // 卖家同意报价
        agreeBargainSellerApi(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/agree',
                method: 'post',
                data
            })
        },
        // 买家再次报价
        bargainBuyerAgainOfferPrice(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/offer/price/again',
                method: 'post',
                data
            })
        },
        // 买家拒绝砍价
        bargainBuyerRefuse(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/refuse',
                method: 'post',
                data
            })
        },
        // 买家同意还价
        bargainBuyerAgree(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/agree',
                method: 'post',
                data
            })
        },
        // 买家取消砍价-放弃砍价
        bargainBuyerCancel(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/cancel',
                method: 'post',
                data
            })
        },
        // 买家砍价详情
        bargainBuyerDetail(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/detail',
                method: 'post',
                data
            })
        },
        // 买家砍价详情历史砍价
        bargainBuyerDetailHistory(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/detail/records',
                method: 'post',
                data
            })
        },
        // 砍价入口校验
        bargainCheck(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/entrance/check',
                method: 'post',
                data
            })
        },
        // 买卖家红点清除
        bargainRedDotCanel(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/red/dot/canel',
                method: 'post',
                data
            })
        },
        // 买卖家红点
        getBargainRedDot(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/red/dot/get',
                method: 'post',
                data
            })
        },
        // 砍价列表联系客服获取群id
        getBargainLinkCustomer(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/get/link/customer',
                method: 'post',
                data
            })
        },
        // 获取卖家砍价详情
        getBargainSellerDetail(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/detail',
                method: 'post',
                data
            })
        },
        // 获取卖家砍价详情历史砍价
        getBargainSellerDetailHistory(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/detail/records',
                method: 'post',
                data
            })
        },
        // 买家订单待办
        getBuyerOrderTodo(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/buyer/order/todo',
                method: 'get',
                data
            })
        },
        // 卖家订单待办
        getSellerOrderTodo(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/seller/order/todo',
                method: 'get',
                data
            })
        },
        // 卖家商品待办
        getSellerGoodsTodo(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/good/todo',
                method: 'get',
                data
            })
        },
        // 砍价买卖家红点
        getBargainDot(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/red/dot/get',
                method: 'post',
                data
            })
        },
        // 清除砍价买卖家红点
        clearBargainDot(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/red/dot/canel',
                method: 'post',
                data
            })
        },
        // 获取每天额外赠送手动曝光次数
        exposureNum(data) {
            return app.$requestApi({
                url: '/web-client/v2/goods/exposure/config',
                method: 'post',
                data
            })
        },
        // 催买卖家
        groupRemind(data) {
            return app.$requestApi({
                url: '/web-client/v2/group/remind',
                method: 'get',
                data
            })
        },
        // 查询是否已砍价
        checkHasBargain(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/entrance/check/v2',
                method: 'post',
                data
            })
        },
        // 砍价成功提醒内容
        bargainSuccessTip(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/buyer/success/not/pain/tip',
                method: 'post',
                data
            })
        },
        // 自己是否黑号查询
        checkBlackMeApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/check/blacklist/me',
                method: 'get',
                data
            })
        },
        // 获取当前登录用户vip历史会话id列表
        getVipConversation(data) {
            return app.$requestApi({
                url: '/web-client/v2/vip/conversation/history',
                method: 'get',
                data
            })
        },
        // 获取当前登录用户vip历史会话id列表
        vipConversationDeleteMark(data) {
            return app.$requestApi({
                url: '/web-client/v2/vip/conversation/history/mark/delete',
                method: 'post',
                data
            })
        },
        // 卖家砍价列表-多笔砍价共存的列表
        bargainSellerManyList(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/many/list',
                method: 'post',
                data
            })
        },
        // 4.2.0 卖家用户一键清除红点
        bargainAllCanelAPI(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/user/red/dot/all/canel',
                method: 'post',
                data
            })
        },
        // 卖家设置自动同意报价
        bargainBuyerSetAutoAgree(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/set/auto/agree',
                method: 'post',
                data
            })
        },
        // 卖家商品历史砍价列表
        bargainSellerHistoryList(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/list/history',
                method: 'post',
                data
            })
        },
        // 卖家商品当前砍价列表
        bargainSellerCurrentList(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/list/current',
                method: 'post',
                data
            })
        },
        // 卖家砍价列表商品信息
        bargainSellerGoodsInfo(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/seller/bargain/list/goods/info',
                method: 'post',
                data
            })
        },
        // 获取订单的收款账户信息
        getReceiverAccountApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/get/receiver/account',
                method: 'get',
                data
            })
        },
        // 个人中心我的劵包红点
        getUserCenterNewCouponApi(data) {
            return app.$requestApi({
                url: '/activity/coupon/user/center/new/coupon',
                method: 'post',
                data
            })
        },
        // 获取前置属性-商品截图方式
        postPrePropertyOptions(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/pre/property/options',
                method: 'post',
                data
            })
        },
        // 个人中心移除券[新]标签
        clearUserCenterNewCouponApi(data) {
            return app.$requestApi({
                url: '/activity/coupon/remove/new/label',
                method: 'post',
                data
            })
        },
        // 获取推荐筛选属性
        postGoodsPublicSearchProperties(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/search/properties',
                method: 'post',
                data
            })
        },
        // 获取放心购用户配置
        confidenceUserConfigAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/service/order/confidence/buy/user/config',
                method: 'post',
                data
            })
        },
        // 获取用户商品报价设置
        bargainUserGoodsConfigApi(data) {
            return app.$requestApi({
                url: '/web-client/v3/bargain/user/goods/config/get',
                method: 'post',
                data
            })
        },
        getAameAccount(data) {
            return app.$requestApi({
                url: '/workorder/user/order/get/game-account',
                method: 'get',
                data
            })
        },
        // 获取标签咨询客服
        getGameLabelServiceApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/consult/label/get/label/customer/service',
                method: 'get',
                data
            })
        },
        // 分页查询游戏商品月成交榜单列表
        monthsTradesPageAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/game/goods/months/trades/page',
                method: 'post',
                data
            })
        },
        // 获取昨日成交tabs数据
        yesterdayDealGameAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/yesterday/deal/game',
                method: 'get',
                data
            })
        },
        // 获取商品详情里已绑定的连体号列表
        unionBindListApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/goods/details/union/options',
                method: 'get',
                data
            })
        },
        // 获取昨日游戏成交明细列表
        dealGameDetailAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/yesterday/deal/game/detail',
                method: 'post',
                data
            })
        },
        // 推荐游戏列表
        homeRecommendGame(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/home/recommend/game',
                method: 'post',
                data
            })
        },
        // 获取昨日成交图片状态
        dealGameStatusAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/homepage/public/yesterday/deal/game/status',
                method: 'get',
                data
            })
        },
        // 获取用户已/可链接的商品列表
        unionUnBindOptionsApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/goods/union/options',
                method: 'get',
                data
            })
        },
        // 商品连体号绑定操作
        unionBindAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/goods/union/bind',
                method: 'post',
                data
            })
        },
        // 商品连体号解绑操作
        unionUnBindApi(data) {
            return app.$requestApi({
                url: '/web-client/v2/goods/union/unbind',
                method: 'post',
                data
            })
        },
        // 根据订单编号获取群id
        getGroupIdByOrderNo(data) {
            return app.$requestApi({
                url: '/workorder/user/order/get/group/by/order-no',
                method: 'get',
                data
            })
        },
        // 生成合同
        agencyOrderCreateContract(data) {
            return app.$requestApi({
                url: '/web-client/agency/order/create-contract',
                method: 'post',
                data
            })
        },
        // 买家确认放款
        agencyOrderBuyerConfirm(data) {
            return app.$requestApi({
                url: '/web-client/agency/order/buyer-confirm-complete',
                method: 'post',
                data
            })
        },
        // 卖家填写收款账号(中介订单4.2.6新增)
        sellerFillPaymentInformation(data) {
            return app.$requestApi({
                url: '/web-client/agency/order/seller-fill-payment-information',
                method: 'post',
                data
            })
        },
        // 获取反馈身份列表
        listByLevel(data) {
            return app.$requestApi({
                url: '/web-client/v2/suggestion/identityConfig/list/by/level',
                method: 'get',
                data
            })
        },
        // 获取反馈身份列表
        listByPId(data) {
            return app.$requestApi({
                url: '/web-client/v2/suggestion/identityConfig/list/by/pid',
                method: 'get',
                data
            })
        },
        // 标签查询商品底价
        getGoodsPriceByLabel(data) {
            return app.$requestApi({
                url: '/web-client/goods/label/query/goods/labelPrice',
                method: 'post',
                data
            })
        },
        // 获取商品价格根据业务来源
        byBusinessSource(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/query/goods-price/by-business-source',
                method: 'post',
                data
            })
        },
        // 卖家修改商品价格
        recyclePriceChange(data) {
            return app.$requestApi({
                url: '/merchant/mer/recycle/recycle/price/change',
                method: 'post',
                data
            })
        },
        // 咨询卖家
        consultSellerAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/consult-seller',
                method: 'post',
                data
            })
        },
        // 咨询卖家改价
        consultSellerChangePriceAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/consult-seller-change-price',
                method: 'post',
                data
            })
        },
        // 发送我的商品卡片
        orderSendGoodsAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/game/online/order/send-goods',
                method: 'post',
                data
            })
        },
        // 发送我的商品卡片
        recycleSendRecycleBargainingMsgAPI(data) {
            return app.$requestApi({
                url: '/merchant/mer/recycle/send/recycle/bargaining/msg',
                method: 'post',
                data
            })
        },
        // 群禁言-解禁
        userGoodsBanAPI(data) {
            return app.$requestApi({
                url: '/content/user/goods/ban',
                method: 'post',
                data
            })
        },
        // 审核用户发送的消息是否违规
        reviewMessageAPI(data) {
            return app.$requestApi({
                url: '/content/ai/customer/review/message',
                method: 'post',
                data
            })
        },
        // 是否已申请解禁 判断当前群聊已禁言再调用这个接口
        applyBanAPI(data) {
            return app.$requestApi({
                url: '/content/user/goods/is/apply/ban',
                method: 'post',
                data
            })
        },
        // 申请解禁
        sendBanCardAPI(data) {
            return app.$requestApi({
                url: '/content/user/goods/send/ban/card',
                method: 'post',
                data
            })
        },
        // 催上线次数查询
        remindOnlineQueryAPI(data) {
            return app.$requestApi({
                url: '/content/ai/customer/remind/online/query',
                method: 'get',
                data
            })
        },
        // 催上线
        remindOnlineAPI(data) {
            return app.$requestApi({
                url: '/content/ai/customer/remind/online',
                method: 'post',
                data
            })
        },
        // 敏感词校验
        chenckSensitive(data) {
            return app.$requestApi({
                url: '/content/ai/sensitive/verify',
                method: 'post',
                data
            })
        },
        // 消息盒子详情 - 消息列表
        messageBoxListAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/box/list',
                method: 'post',
                data
            })
        },
        // 获取砍价消息未读数量
        getUnReadMessageCountAPI() {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/sessions/un_reads',
                method: 'get'
            })
        },
        // 创建砍价IM会话
        bargainImCreateAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/create',
                method: 'post',
                data
            })
        },
        // 砍价im 消息顶部信息
        bargainImMessageTopAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/top',
                method: 'get',
                data
            })
        },
        // 申请售后工单问题列表
        afterSalesQuestionListAPI(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/question/list',
                method: 'get',
                data
            })
        },
        // 砍价im 消息列表
        bargainImMessageHistoryAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/history',
                method: 'post',
                data
            })
        },
        // 申请售后V2(购后专项2025-5-13)
        afterSalesV2ApplyAPI(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/v2/apply',
                method: 'post',
                data
            })
        },
        // 砍价im 查询当前出价信息
        bargainImCounterOfferInfoAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/counterOfferInfo',
                method: 'post',
                data
            })
        },
        // 砍价im 消息盒子详情
        bargainImMessageBoxDetailsAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/box/details',
                method: 'post',
                data
            })
        },
        // 砍价im 买家修改出价
        bargainImBuyerUpdatePriceAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/buyer/update/price',
                method: 'post',
                data
            })
        },
        // 砍价im 事件
        bargainImEventAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/event',
                method: 'post',
                data
            })
        },
        // 砍价im 买家脚本配置
        bargainImBuyerScriptConfigAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/buyer/scriptConfig',
                method: 'get',
                data
            })
        },
        // 发送捎一句话
        bargainImBuyerSendScriptAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/buyer/sendMsg',
                method: 'post',
                data
            })
        },
        // 砍价im 砍价前置入口校验
        bargainImEntranceCheckAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/entrance/check',
                method: 'post',
                data
            })
        },
        // 砍价im 买家还价
        bargainImBuyerCounterOfferAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/buyer/counterOffer',
                method: 'post',
                data
            })
        },
        // 砍价im 卖家还价
        bargainImSellerCounterOfferAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/seller/counterOffer',
                method: 'post',
                data
            })
        },
        // 砍价im 卖家同意还价
        bargainImSellerAgreeAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/seller/agree',
                method: 'post',
                data
            })
        },
        // 砍价im 卖家拒绝还价
        bargainImSellerRefuseCounterOfferAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/seller/refuseCounterOffer',
                method: 'post',
                data
            })
        },
        // 砍价im 卖家获取还价配置
        bargainImSellerGetCounterOfferConfigAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/seller/getCounterOfferConfig',
                method: 'post',
                data
            })
        },
        // 砍价im 卖家设置还价配置
        bargainImSellerSetCounterOfferConfigAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/seller/setCounterOfferConfig',
                method: 'post',
                data
            })
        },
        // 砍价im 创建砍价订单
        bargainImCreateOrderAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/order/create/for/bargain/im',
                method: 'post',
                data
            })
        },
        // 砍价im 买家同意砍价
        bargainImBuyerAgreeAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/offline/buyer/agree',
                method: 'get',
                data
            })
        },

        // 砍价成功引导下单
        getBargainSuccessInfoAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/success/goods/detail',
                method: 'get',
                data
            })
        },
        // 砍价im 批量确认消息已读
        bargainImMessageBatchAckAPI(data) {
            return app.$requestApi({
                url: '/web-client/v4/bargain/im/message/batch_ack',
                method: 'post',
                data
            })
        },
        // 卖家通知
        setSellerGuideGoodsAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/user/guide/Sell/goods',
                method: 'post',
                data
            })
        },
        // 售后评价
        afterSalesEvaluationAPI(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/service/evaluation',
                method: 'post',
                data
            })
        },
        // 售后评价提交
        afterSalesEvaluationSubmitAPI(data) {
            return app.$requestApi({
                url: '/workorder/user/after-sales/service/evaluation/add',
                method: 'post',
                data
            })
        },
        /** @改价改包赔 **/
        // 改价改包赔-买家支付前确认,返回true才可以支付
        changePricePayConfirm(data, options) {
            return app.$requestApi({
                url: '/workorder/change-price-pay-confirm',
                method: 'get',
                data,
                options
            })
        },

        // 改价改包赔-买卖家确认
        changePriceConfirm(data, options) {
            return app.$requestApi({
                url: '/workorder/change-price-confirm',
                method: 'post',
                data,
                options
            })
        },
        // 交易取消,买家提供收款账户
        submitCancelBuyerAccount(data, options) {
            return app.$requestApi({
                url: '/workorder/modify/order/buyer/submit/payment/account',
                method: 'post',
                data,
                options
            })
        },
        // 工单3.5
        // 买家验号
        workOrder35BuyerVerifyAccount(data, options) {
            return app.$requestApi({
                url: '/workorder/work-order-35/buyer/verify-account',
                method: 'post',
                data,
                options
            })
        },
        // 根据群聊id查询节点信息
        workOrder35GetNodeByGroup(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/get/node/by/group',
                method: 'get',
                data,
                options
            })
        },
        // 查询卖家订单财务打款状态
        workOrder35GetOrderFinanceStatus(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/get/order/finance/status',
                method: 'get',
                data,
                options
            })
        },
        // 查询买家退款状态
        workOrder35GetBuyerFinanceStatus(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/get/order/refund/status',
                method: 'get',
                data,
                options
            })
        },
        // 卖家提交收款账户-签署合同
        workOrder35SubmitAccountSignContract(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/submit/account/sign/contract',
                method: 'post',
                data,
                options
            })
        },
        // 卖家包赔资料补充
        workOrder35SellerSupplementCompensationInfo(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/supplement/compensation/info',
                method: 'post',
                data,
                options
            })
        },
        // 获取续保合作平台
        workOrder35GetCooperationPlatform(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/get/cooperation/platform',
                method: 'get',
                data,
                options
            })
        },
        // 法大大获取参与方签署链接
        workOrder35GetFDDSignUrl(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/get/actor/url',
                method: 'post',
                data,
                options
            })
        },
        // 3.5 提交满意度评价复制接口复制文档复制地址
        workOrder35SubmitSatisfactionEvaluation(data, options) {
            return app.$requestApi({
                url: '/workorder/satisfaction/evaluation/submit',
                method: 'post',
                data,
                options
            })
        },
        // 线下交易提交退款账户
        workOrder35SubmitRefundAccount(data, options) {
            return app.$requestApi({
                url: '/workorder/user/order/submit/offline/refund/account',
                method: 'post',
                data,
                options
            })
        },
        // 查看验号报告
        workOrder35GoodsCheckReport(data, options) {
            return app.$requestApi({
                url: '/workorder/goods/check/report',
                method: 'get',
                data,
                options
            })
        },
        // 获取商品代付配置
        getStagePayConfigAPI(data) {
            return app.$requestApi({
                url: '/web-client/v1/agent/pay/getConfig',
                method: 'post',
                data
            })
        },
        // CDkey兑换
        exchangeCdkey(data) {
            return app.$requestApi({
                url: '/activity/cdk/consume',
                method: 'post',
                data
            })
        },

        // cdkey兑换详情
        // data: {code: 'xxx'}
        exchangeCdkeyDetail(data) {
            return app.$requestApi({
                url: '/activity/cdk/consume/detail',
                method: 'post',
                data
            })
        },

        // 获取限制商城状态
        getRestrictMallAPI() {
            return app.$requestApi({
                url: '/web-client/v2/userCenter/current/restriction',
                method: 'post'
            })
        },
        //检查卖家限制状态
        getSellerRestrictMallAPI(data) {
            return app.$requestApi({
                url: '/web-client/v2/get/user/restriction',
                method: 'get',
                data
            })
        },
        // 站内消息批量回执
        stationNotifyRecall(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/station_notify/recall',
                method: 'post',
                data,
                options
            })
        },
        // 投诉工单评价
        getComplaintDetail(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/complain/detail',
                method: 'get',
                data
            })
        },
        // 投诉工单评价
        submitComplaintEvaluate(data) {
            return app.$requestApi({
                url: '/web-client//v2/public/complain/submit/evaluate',
                method: 'post',
                data
            })
        },
        // 商详页最优优惠劵计算
        optimalCoupon(data) {
            return app.$requestApi({
                url: '/activity/coupon/calculate/optimal/coupon',
                method: 'get',
                data
            })
        },
        // 获取曝光优惠券列表
        getExposureCouponList(data) {
            return app.$requestApi({
                url: '/activity/coupon/wait/exposure/select/list',
                method: 'post',
                data
            })
        },
        // 可用曝光劵数量
        exposureCouponCount(data) {
            return app.$requestApi({
                url: '/activity/coupon/wait/exposure/count',
                method: 'post',
                data
            })
        },
        // 曝光劵使用
        useExposureCoupon(data) {
            return app.$requestApi({
                url: '/activity/coupon/use/exposure/coupon',
                method: 'post',
                data
            })
        },
        // 优惠券分组数量
        couponGroupCount(data) {
            return app.$requestApi({
                url: '/activity/coupon/my/couponGroupCount',
                method: 'post',
                data
            })
        },
        /**
         * 通用商品发布
         */
        // 新商品发布-获取商品类目
        getPublishGeneralCatalogue(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/goods/publish/general/sub/catalogue',
                method: 'get',
                data,
                ...options
            })
        },
        // 通用商品发布-获取发布流
        getPublishGeneralFlowId(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/goods/publish/general/flow',
                method: 'post',
                data,
                ...options
            })
        },
        // 通用商品发布-获取发布属性
        getPublishGeneralFlowAttrs(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/goods/publish/general/flow/attrs',
                method: 'post',
                data,
                ...options
            })
        },
        // 通用商品发布-保存商品
        saveGeneralGoods(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/goods/publish/general/flow/goods/save',
                method: 'post',
                data,
                ...options
            })
        },

        // ==================== 卖家侧-通用商品管理 ====================

        // 卖家侧-通用商品SPU详情
        getGeneralGoodsSpuDetail(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/seller/spu',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-通用商品SKU详情
        getGeneralGoodsSkuDetail(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/seller/sku',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-通用商品游戏类目列表
        getGeneralGoodsCateList(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/games/categories',
                method: 'get',
                data,
                ...options
            })
        },

        // 卖家侧-通用商品列表
        getGeneralGoodsList(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/page',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-获取价格属性
        getGeneralGoodsPriceAttrs(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/price/attrs',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-修改价格
        onGeneralGoodsPriceUpdate(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/price/update',
                method: 'post',
                data,
                ...options
            })
        },

        // 商品详情-卖家相关信息
        getGeneralGoodsSellerInfo(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/seller/data',
                method: 'get',
                data,
                ...options
            })
        },

        // ==================== 卖家侧-套餐管理 ====================

        // 卖家侧-套餐-添加
        onGeneralGoodsSkuAdd(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/sku/add',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-套餐-删除
        onGeneralGoodsSkuDelete(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/sku/delete',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-套餐-启用-停用
        onGeneralGoodsSkuEnable(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/sku/enable',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-套餐-设置主套餐
        onGeneralGoodsSkuSetMaster(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/sku/setMaster',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-套餐-编辑
        onGeneralGoodsSkuUpdate(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/sku/update',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-修改商品状态
        onGeneralGoodsStatusUpdate(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/status/update',
                method: 'post',
                data,
                ...options
            })
        },

        // 卖家侧-商品删除
        onGeneralGoodsDelete(data, options) {
            return app.$requestApi({
                url: '/web-client/user/general_goods/delete',
                method: 'post',
                data,
                ...options
            })
        },

        // 通用商品发布-前置检测
        generalGoodsCheck(data, options) {
            return app.$requestApi({
                url: '/web-client/v2/goods/publish/general/check/publish',
                method: 'post',
                data,
                ...options
            })
        },
        //获取卖家在线状态 不校验登录状态
        findSellerOnlineStates(data) {
            return app.$requestApi({
                url: '/web-client/v2/public/goodsPublic/findSellerOnlineStatus',
                method: 'get',
                data
            })
        },
        //获取当前商品想要和看过数据
        getGoodsWantAndSeenNum(data) {
            return app.$requestApi({
                url: '/dashboard/public/goodsPublic/goodsPageLabel',
                method: 'post',
                data
            })
        },
        // 获取商详页用户查看商品轮播数据
        getUserCarouselListAPI(data) {
            return app.$requestApi({
                url: '/dashboard/public/goodsPublic/goodsDetailCarousel',
                method: 'get',
                data
            })
        },
        	// 支持游戏
        getGameList(data) {
            return app.$requestApi({
                url: '/activity/benefit/game/page',
                method: 'post',
                data
            })
        },
        joinGroup(data) {
            return app.$requestApi({
                url: '/activity/benefit/join/group',
                method: 'post',
                data
            })
        },
        // 推广用户身份
        getUserIdentity(data) {
            return app.$requestApi({
                url: '/activity/benefit/user/identity',
                method: 'post',
                data
            })
        },
        // 我的推广-我的奖励 
        getMyPopularizer(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/popularizer',
                method: 'get',
                data
            })
        },

        // 我的推广-我的邀请码
        getApply(data) {
            return app.$requestApi({
                url: '/activity/benefit/group/apply/record',
                method: 'get',
                data
            })
        },
        // 我邀请的好友
        getMyInviteFriend(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/invite',
                method: 'get',
                data
            })
        },
        // 我邀请的组员
        getMyInviteGroup(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/group',
                method: 'get',
                data
            })
        },
        // 我的奖励列表
        getMyPopularizerList(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/game/benefit/page',
                method: 'post',
                data
            })
        },
        // 我邀请的组员列表	
        getMyInviteGroupList(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/invite/page',
                method: 'post',
                data
            })
        },
        // 我要求的好友列表
        getMyInviteFriendList(data) {
            return app.$requestApi({
                url: '/activity/benefit/my/group/page',
                method: 'post',
                data
            })
        },
        // 获取推广码
        getActivityBenefitInviteCode(data) {
            return app.$requestApi({
                url: '/activity/benefit/invite/code',
                method: 'get',
                data
            })
        },
        // 校验邀请码
        checkActivityBenefitInviteCode(data) {
            return app.$requestApi({
                url: `/activity/benefit/check/${data}`,
                method: 'post',
            })
        },
    }
    // 注入到全局nuxt示例中
    inject('api', _API)
}
